// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.patientList-navbar-brand span {
  font-size: 18px;
  font-weight: bold;
  color: #ffffff;
}

#main {
  background: #1e1e1e;
  color: #cccccc;
  display: flex;
  flex-direction: column;
  height: 100%;
}

#main h3 {
  color: #ffffff;
}

.patientListHeader {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 15px 20px;
  background: #252526;
  border-bottom: 1px solid #3e3e42;
  flex-shrink: 0;
}

.patients-label {
  font-size: 18px;
  font-weight: bold;
  color: #ffffff;
  flex: 0 0 auto;
}

.search-bar {
  flex: 1 1;
  max-width: 400px;
  margin: 0 20px;
  padding: 8px 12px;
  background: #3c3c3c;
  border: 1px solid #3e3e42;
  border-radius: 4px;
  color: #cccccc;
  font-size: 14px;
  outline: none;
}

.search-bar:focus {
  border-color: #333333;
  background: #2d2d30;
}

.search-bar::placeholder {
  color: #858585;
}

.patients-count {
  font-size: 16px;
  font-weight: 600;
  color: #cccccc;
  background: #2d2d30;
  padding: 6px 12px;
  border-radius: 4px;
  flex: 0 0 auto;
}

.patientList-reload-button {
  color: #cccccc;
  background: #2d2d30;
  padding: 6px 12px;
  border: 1px solid #3e3e42;
  border-radius: 4px;
}

.patientList-reload-button:hover {
  background: #37373d;
}

.patientListContainer {
  border: solid #3e3e42 1px;
  flex: 1 1;
  overflow-y: auto;
  overflow-x: hidden;
}

.table {
  background: #252526;
  color: #cccccc;
  margin: 0;
  width: 100%;
  table-layout: fixed;
  --bs-table-bg: #252526;
  --bs-table-color: #cccccc;
  --bs-table-border-color: #3e3e42;
  --bs-table-striped-bg: #2d2d30;
  --bs-table-striped-color: #cccccc;
  --bs-table-hover-bg: #37373d;
  --bs-table-hover-color: #ffffff;
}

.table thead th {
  background: #2d2d30 !important;
  color: #ffffff !important;
  border-color: #3e3e42 !important;
}

/* ID */
.table thead th:nth-child(1) {
  width: 30%;
}

/* Name */
.table thead th:nth-child(2) {
  width: 20%;
}

/* Modality */
.table thead th:nth-child(3) {
  width: 10%;
}

/* Study Description */
.table thead th:nth-child(4) {
  width: 25%;
}

/* # Images */
.table thead th:nth-child(5) {
  width: 7.5%;
}

/* Date */
.table thead th:nth-child(6) {
  width: 7.5%;
}



.table td {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.table tbody tr {
  background-color: #252526 !important;
  color: #cccccc !important;
}

.table>tbody>tr:nth-of-type(odd)>* {
  background-color: #252526 !important;
  color: #cccccc !important;
}

.table>tbody>tr:nth-of-type(even)>* {
  background-color: #2d2d30 !important;
  color: #cccccc !important;
}

.table>tbody>tr>td,
.table>thead>tr>th {
  border-color: #3e3e42 !important;
  color: #cccccc !important;
}

.table>tbody>tr:hover>*,
.table>tbody>tr:hover {
  background-color: #37373d !important;
  color: #ffffff !important;
}

.patientList-table {
  cursor: pointer;
}

.patientList-table:hover,
.patientList-table:hover>* {
  background-color: #37373d !important;
  color: #ffffff !important;
}

/* Pagination Styles */
.pagination {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 20px;
  background: #252526;
  border-top: 1px solid #3e3e42;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 100;
}

.pagination-btn {
  padding: 8px 12px;
  background: #2d2d30;
  color: #cccccc;
  border: 1px solid #3e3e42;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  transition: all 0.2s ease;
  min-width: 40px;
}

.pagination-btn:hover:not(:disabled) {
  background: #37373d;
  color: #ffffff;
  border-color: #007acc;
}

.pagination-btn.active {
  background: #007acc;
  color: #ffffff;
  border-color: #007acc;
  font-weight: bold;
}

.pagination-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.pagination-ellipsis {
  padding: 8px 4px;
  color: #858585;
}

.pagination-info {
  margin-left: 20px;
  color: #858585;
  font-size: 14px;
  min-width: 200px;
  text-align: left;
}`, "",{"version":3,"sources":["webpack://./src/components/PatientList.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,mBAAmB;EACnB,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,SAAO;EACP,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,SAAS;EACT,WAAW;EACX,mBAAmB;EACnB,sBAAsB;EACtB,yBAAyB;EACzB,gCAAgC;EAChC,8BAA8B;EAC9B,iCAAiC;EACjC,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA,OAAO;AACP;EACE,UAAU;AACZ;;AAEA,SAAS;AACT;EACE,UAAU;AACZ;;AAEA,aAAa;AACb;EACE,UAAU;AACZ;;AAEA,sBAAsB;AACtB;EACE,UAAU;AACZ;;AAEA,aAAa;AACb;EACE,WAAW;AACb;;AAEA,SAAS;AACT;EACE,WAAW;AACb;;;;AAIA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;;EAEE,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;;EAEE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;;AAEA;;EAEE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,eAAe;EACf,SAAS;EACT,OAAO;EACP,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB","sourcesContent":[".patientList-navbar-brand span {\n  font-size: 18px;\n  font-weight: bold;\n  color: #ffffff;\n}\n\n#main {\n  background: #1e1e1e;\n  color: #cccccc;\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n}\n\n#main h3 {\n  color: #ffffff;\n}\n\n.patientListHeader {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 15px 20px;\n  background: #252526;\n  border-bottom: 1px solid #3e3e42;\n  flex-shrink: 0;\n}\n\n.patients-label {\n  font-size: 18px;\n  font-weight: bold;\n  color: #ffffff;\n  flex: 0 0 auto;\n}\n\n.search-bar {\n  flex: 1;\n  max-width: 400px;\n  margin: 0 20px;\n  padding: 8px 12px;\n  background: #3c3c3c;\n  border: 1px solid #3e3e42;\n  border-radius: 4px;\n  color: #cccccc;\n  font-size: 14px;\n  outline: none;\n}\n\n.search-bar:focus {\n  border-color: #333333;\n  background: #2d2d30;\n}\n\n.search-bar::placeholder {\n  color: #858585;\n}\n\n.patients-count {\n  font-size: 16px;\n  font-weight: 600;\n  color: #cccccc;\n  background: #2d2d30;\n  padding: 6px 12px;\n  border-radius: 4px;\n  flex: 0 0 auto;\n}\n\n.patientList-reload-button {\n  color: #cccccc;\n  background: #2d2d30;\n  padding: 6px 12px;\n  border: 1px solid #3e3e42;\n  border-radius: 4px;\n}\n\n.patientList-reload-button:hover {\n  background: #37373d;\n}\n\n.patientListContainer {\n  border: solid #3e3e42 1px;\n  flex: 1;\n  overflow-y: auto;\n  overflow-x: hidden;\n}\n\n.table {\n  background: #252526;\n  color: #cccccc;\n  margin: 0;\n  width: 100%;\n  table-layout: fixed;\n  --bs-table-bg: #252526;\n  --bs-table-color: #cccccc;\n  --bs-table-border-color: #3e3e42;\n  --bs-table-striped-bg: #2d2d30;\n  --bs-table-striped-color: #cccccc;\n  --bs-table-hover-bg: #37373d;\n  --bs-table-hover-color: #ffffff;\n}\n\n.table thead th {\n  background: #2d2d30 !important;\n  color: #ffffff !important;\n  border-color: #3e3e42 !important;\n}\n\n/* ID */\n.table thead th:nth-child(1) {\n  width: 30%;\n}\n\n/* Name */\n.table thead th:nth-child(2) {\n  width: 20%;\n}\n\n/* Modality */\n.table thead th:nth-child(3) {\n  width: 10%;\n}\n\n/* Study Description */\n.table thead th:nth-child(4) {\n  width: 25%;\n}\n\n/* # Images */\n.table thead th:nth-child(5) {\n  width: 7.5%;\n}\n\n/* Date */\n.table thead th:nth-child(6) {\n  width: 7.5%;\n}\n\n\n\n.table td {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.table tbody tr {\n  background-color: #252526 !important;\n  color: #cccccc !important;\n}\n\n.table>tbody>tr:nth-of-type(odd)>* {\n  background-color: #252526 !important;\n  color: #cccccc !important;\n}\n\n.table>tbody>tr:nth-of-type(even)>* {\n  background-color: #2d2d30 !important;\n  color: #cccccc !important;\n}\n\n.table>tbody>tr>td,\n.table>thead>tr>th {\n  border-color: #3e3e42 !important;\n  color: #cccccc !important;\n}\n\n.table>tbody>tr:hover>*,\n.table>tbody>tr:hover {\n  background-color: #37373d !important;\n  color: #ffffff !important;\n}\n\n.patientList-table {\n  cursor: pointer;\n}\n\n.patientList-table:hover,\n.patientList-table:hover>* {\n  background-color: #37373d !important;\n  color: #ffffff !important;\n}\n\n/* Pagination Styles */\n.pagination {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  padding: 20px;\n  background: #252526;\n  border-top: 1px solid #3e3e42;\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  z-index: 100;\n}\n\n.pagination-btn {\n  padding: 8px 12px;\n  background: #2d2d30;\n  color: #cccccc;\n  border: 1px solid #3e3e42;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 14px;\n  transition: all 0.2s ease;\n  min-width: 40px;\n}\n\n.pagination-btn:hover:not(:disabled) {\n  background: #37373d;\n  color: #ffffff;\n  border-color: #007acc;\n}\n\n.pagination-btn.active {\n  background: #007acc;\n  color: #ffffff;\n  border-color: #007acc;\n  font-weight: bold;\n}\n\n.pagination-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.pagination-ellipsis {\n  padding: 8px 4px;\n  color: #858585;\n}\n\n.pagination-info {\n  margin-left: 20px;\n  color: #858585;\n  font-size: 14px;\n  min-width: 200px;\n  text-align: left;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
